import PaymentResults from './PaymentResults'

export default PaymentResults
